module.exports = __webpack_public_path__ + "static/media/Pruefung202505.df324fe2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Pruefung202505.jpg
// module id = 364
// module chunks = 0